var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMenuMusic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2103",
    "data-name": "Group 2103",
    transform: "translate(-1039 -447)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_125",
    "data-name": "Ellipse 125",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(1039 447)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "music",
    transform: "translate(1033.913 439.527)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2228",
    "data-name": "Path 2228",
    d: "M37.082,76.03v.058a.235.235,0,0,1,0,.041C37.082,76.1,37.082,76.064,37.082,76.03Z",
    transform: "translate(-18.2 -46.483)",
    fill: "#816920"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2229",
    "data-name": "Path 2229",
    d: "M29.1,15.56v12.06c0,.029,0,.058,0,.085a2.945,2.945,0,0,1-2.24,2.4c-1.563.464-3.126-.145-3.488-1.364s.607-2.586,2.17-3.053a3.481,3.481,0,0,1,1.87-.053V17.795L18.883,20.48v9.067c0,.034,0,.065,0,.1a.236.236,0,0,1,0,.058,2.958,2.958,0,0,1-2.24,2.371c-1.56.467-3.123-.145-3.486-1.364s.607-2.586,2.17-3.051a3.482,3.482,0,0,1,1.87-.056V18.668a.846.846,0,0,1,.6-.81L28.01,14.752a.843.843,0,0,1,1.091.808Z",
    fill: "#816920"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuMusic);
export default __webpack_public_path__ + "static/media/icon-menu-music.88ca94e4.svg";
export { ForwardRef as ReactComponent };